/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/Time"
  
}) {
let eventValueData = fromData.useDataFormat({ viewPath,
context: 'event',
format: fromFormat.formatTimegridAppointmentTime,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event"
 format="/Data/format.js formatTimegridAppointmentTime"
 text={eventValueData}
 weight="medium"
 color={dtColorsNeutral600}
 marginRight={dtSpaceXxs}
 size="small"
 whiteSpace="nowrap"
/>
{children}
</React.Fragment>)
}